export const getTimeString = (time: string): string => {
    const timeArray: string[] = time.split(":");
    timeArray.splice(2, 1);
    return timeArray.join(":");
}